import { useState } from "react";

const useExpensesAccountSettings = (findAccountMapping) => {
  const [expensesAccountMapping, setExpensesAccountMapping] = useState({
    expense_account:
      findAccountMapping("expense_account")?.chart_account?.id || "",
    account_payable_account:
      findAccountMapping("account_payable_account")?.chart_account?.id || "",
    pos_fee_account:
      findAccountMapping("pos_fee_account")?.chart_account?.id || "",
  });

  return {
    expensesAccountMapping,
    setExpensesAccountMapping,
  };
};

export default useExpensesAccountSettings;
